// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--fa5e6";
export var headingContainer = "index-module--heading-container--80394";
export var highlight = "index-module--highlight--f7c22";
export var highlightLine = "index-module--highlight-line--5e8ee";
export var image1 = "index-module--image-1--612fd";
export var image2 = "index-module--image-2--a54e8";
export var imageContainer = "index-module--image-container--f3dbb";